// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".template-picker-modal--Rxvzj.template-picker-modal--Rxvzj .template-grid{--template-tile-min-width: 280px;--template-tile-min-width-square: 240px;--template-tile-min-width-fourfive: 220px;--template-tile-min-width-vertical: 180px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"template-picker-modal": "template-picker-modal--Rxvzj"
};
export default ___CSS_LOADER_EXPORT___;
